import { IconProps } from '.';

const TwoIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      className={customClasses}
      {...rest}
    >
      <g clipPath="url(#clip0_18177_142895)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 37.5C29.665 37.5 37.5 29.665 37.5 20C37.5 10.335 29.665 2.5 20 2.5C10.335 2.5 2.5 10.335 2.5 20C2.5 29.665 10.335 37.5 20 37.5ZM20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
          fill={color || 'var(--color-ui-icon-primary)'}
        />
        <path
          d="M14.3441 28.3334V26.3584C14.3441 25.8418 14.4608 25.3084 14.6941 24.7584C14.9441 24.1918 15.2941 23.6334 15.7441 23.0834C16.2108 22.5334 16.7608 22.0251 17.3941 21.5584L20.7691 19.0584C21.1691 18.7751 21.5275 18.4501 21.8441 18.0834C22.1775 17.7001 22.4358 17.3084 22.6191 16.9084C22.8191 16.4918 22.9191 16.0834 22.9191 15.6834C22.9191 15.1501 22.7858 14.6668 22.5191 14.2334C22.2525 13.7834 21.8775 13.4334 21.3941 13.1834C20.9108 12.9168 20.3358 12.7834 19.6691 12.7834C19.0358 12.7834 18.4775 12.9084 17.9941 13.1584C17.5275 13.3918 17.1358 13.7084 16.8191 14.1084C16.5025 14.5084 16.2775 14.9334 16.1441 15.3834L13.6191 14.9084C13.8025 14.1418 14.1608 13.4251 14.6941 12.7584C15.2275 12.0918 15.9108 11.5584 16.7441 11.1584C17.5775 10.7418 18.5191 10.5334 19.5691 10.5334C20.7691 10.5334 21.8025 10.7584 22.6691 11.2084C23.5525 11.6418 24.2358 12.2501 24.7191 13.0334C25.2025 13.8001 25.4441 14.6834 25.4441 15.6834C25.4441 16.6501 25.1775 17.5418 24.6441 18.3584C24.1275 19.1751 23.3775 19.9668 22.3941 20.7334L19.2691 23.0834C18.6525 23.5501 18.1608 24.0334 17.7941 24.5334C17.4441 25.0334 17.2275 25.5668 17.1441 26.1334H25.6691V28.3334H14.3441Z"
          fill={color || 'var(--color-ui-icon-primary)'}
        />
      </g>
      <defs>
        <clipPath id="clip0_18177_142895">
          <rect
            width="40"
            height="40"
            fill={color || 'var(--color-ui-icon-primary)'}
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TwoIcon;
